/**
 * گزینه‌های یادآورِ برنامه‌ی قطعی‌شده (WHOSUP-134).
 *
 * یک فهرست برای هر دو اپ، تا «چه گزینه‌هایی هست» دو نسخه نشود. مقدار به
 * دقیقه است — همان `plans.reminder_min` — و صفر یعنی «بدون یادآور»
 * (تابعِ `confirm_signal_plan` برای صفر هیچ ردیفی نمی‌سازد).
 */
export const REMINDER_OPTIONS = [
  { min: 0, key: 'reminderNone' },
  { min: 30, key: 'reminder30m' },
  { min: 60, key: 'reminder1h' },
  { min: 120, key: 'reminder2h' },
  { min: 1440, key: 'reminder1d' },
] as const;
